export default "__VITE_ASSET__FWRlXLMr__"